import { Arrow } from "@jog/react-components"
import { Properties } from "@jog/types"

export const Sorting = ({
    onChange,
    sortfields,
}: {
    onChange: (v: string) => void
    sortfields: Properties["sortfields"]
}) => {
    if (!sortfields) return <></>
    return (
        <div className="relative flex w-full flex-wrap">
            <select
                className="w-full appearance-none border border-gray-medium p-3 text-base text-gray-base outline-0 lg:w-auto lg:min-w-[250px]"
                onChange={(event) => onChange(event.target.value)}
                value={sortfields?.find((i) => i.isselected)?.url || sortfields[0]?.url}
                aria-label="Sorting">
                {sortfields.map((item, index) => (
                    <option value={item.url} key={index}>
                        {item.displaytitle}
                    </option>
                ))}
            </select>
            <Arrow color="black" className="absolute right-5 top-1/2 z-[1] -translate-y-1/2" direction="down" />
        </div>
    )
}
